export default __webpack_public_path__ + "static/media/MariaSneaker_Wide.d0f20d7e.jpg";